import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
	const cleanFilter = (text) => {
		return text.replace(/%/g, '')
	}

	app.config.globalProperties.$cleanFilter = cleanFilter
})
